import { request } from './http';
import type { PaginatedResult, PageQuery } from '@/types/api';
import type { WalletTransferRecord, WalletTransferRequest } from '@/types/customer';

export interface WalletTransferQuery extends PageQuery {
  customerId?: string;
  direction?: 'CREDIT' | 'DEBIT';
}

export const walletApi = {
  /** 为指定客户母账户转入或转出资金 */
  transfer(payload: WalletTransferRequest) {
    return request<WalletTransferRecord>({
      url: '/admin/wallet-transfers',
      method: 'POST',
      data: payload,
    });
  },

  list(query?: WalletTransferQuery) {
    return request<PaginatedResult<WalletTransferRecord>>({
      url: '/admin/wallet-transfers',
      method: 'GET',
      params: query,
    });
  },
};
